/**
 * DLO Error Integration Component
 * 
 * This component should be included once in your main DLO layout to provide
 * centralized error handling across all DLO components.
 */

import React from 'react';
import { View } from 'react-native';
import DLOErrorModal from './DLOErrorModal';
import SessionLockConflictModal from '../../sessionLock/components/SessionLockConflictModal';
import LockExpirationWarningModal from '../../sessionLock/components/LockExpirationWarningModal';

interface DLOErrorProviderProps {
  children: React.ReactNode;
  onNavigate?: () => void;
}

/**
 * Provider component that wraps DLO content and provides error handling
 * Include this once in your main DLO layout
 */
export const DLOErrorProvider: React.FC<DLOErrorProviderProps> = ({ children, onNavigate }) => {
  return (
    <View style={{ flex: 1 }}>
      {children}
      
      {/* 
        Global error modal for all DLO operations
        This will automatically show/hide based on error state
      */}
      <DLOErrorModal />
      
      {/* 
        Session lock conflict modal
        Displayed when a resource is locked by another user
      */}
      <SessionLockConflictModal />

      {/* 
        Lock expiration warning modal
        Displayed 30 seconds before lock expires, allows user to extend for 5 more minutes
      */}
      <LockExpirationWarningModal onNavigate={onNavigate} />
    </View>
  );
};

export default DLOErrorProvider;
